<template>
  <div class="indexBox">
    <!-- 比赛开始banner图 -->
    <img class="banner" v-if="bannerShow" :src="bannerIMG" />
    <!-- 因倒计时提示音不能自动播放加此弹窗 -->
    <div class="myPopupBox" v-if="!soundOver">
      <div class="myPopup">
        欢迎使用决赛打分系统
        <img class="guanbi" @click="guanbiFun()" src="https://mc.posedu.com.cn/myAll_Img/dp_gb.png" />
      </div>
    </div>
    <!-- 选手PPT展示 -->
    <div class="PPTBox bg" v-if="false" style="background-image: url(https://mc.posedu.com.cn/myAll_Img/u1.png);">
      <div class="pptTitle">选手PPT展示</div>
      <iframe v-for="(item, index) in pptArr" :key="index" class="myppt" frameborder="0"
        :style="playerId==item.id?'display:block;':'display:none;'" :src="item.src"></iframe>
      <div class="countdown" :style="countdown <=5?'color:red;':''">{{countdown}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        bannerIMG: '',
        bannerShow: true,
        countdown: 10,
        playerId: 1, //选手id
        pptArr: [], //PPT数组
        pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
          '/pages/countdown', '/pages/totalScore_player'
        ], //首页banner、选题、打分、排行、倒计时、总分
        matchId: 1,
        mytype: 0, //环节
        circulateFunTime: null,
        soundOver:true,
      };
    },
    mounted() {
      if(this.$route.query.audioShow == 0){
        this.$store.commit('audioShow_vuex', 0)
      }
      if(this.$route.query.soundOver){
        this.soundOver = this.$route.query.soundOver
      }else{
        this.soundOver = false
      }
      //console.log("this.$route.query", this.$route.query);
      let that = this
      this.matchId = this.$route.query.matchId
      // this.countdownGO_Fun()
      // this.$get("getCache", '?trackId=' + 1, {
      //     matchId: this.matchId,
      //   }).then((res) => {
      //     //console.log('getCache', res.data);

      //   })
      //   .catch((err) => {});
      this.$post("backdrop_list", {}, {
          matchId: this.matchId,
        }).then((res) => {
          //console.log('backdrop_list', res.data);
          this.bannerIMG = res.data[0].matchStartBg
          sessionStorage.setItem('hostUrl',res.data[0].hostUrl)
          sessionStorage.setItem('technicalSupportUrl',res.data[0].technicalSupportUrl)

        })
        .catch((err) => {});
      this.data_acquisition()
    },
    destroyed() {
      let that = this
      window.clearTimeout(that.circulateFunTime)
    },
    methods: {
      countdownGO_Fun() {
        let _that = this
        var timer = setInterval(() => {
          _that.countdown -= 1
          if (_that.countdown <= 0) {
            clearInterval(timer)
          }
        }, 1000)
      },
      data_acquisition() {
        this.$get("gerSecondConsoleInfo", '?trackId=' + 1, {
            matchId: this.matchId,
          }).then((res) => {
            sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
            //console.log('gerSecondConsoleInfo', res.data);
            if (!res.data.type) {
              this.circulateFunTime = window.setTimeout(() => {
                this.data_acquisition()
              }, 1000);
            } else {
              this.mytype = res.data.type
              let that = this
              let routerNum = null
              if (res.data.type == null) {
                routerNum = 0
              } else if (res.data.type == 4) {
                routerNum = 1
              } else if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
                routerNum = 2
              } else if (res.data.type == 9) {
                routerNum = 3
              } else if (res.data.type == 1 || res.data.type == 2 || res.data.type == 7) {
                routerNum = 4
              } else if (res.data.type == 6) {
                routerNum = 5
              }
              if (routerNum != null) {
                this.$router.push({
                  path: this.pagesArr[routerNum],
                  query: {
                    matchId: this.matchId,
                  },
                });
                window.clearTimeout(that.circulateFunTime)
              }
            }
          })
          .catch((err) => {});
      },
      guanbiFun(){
        this.soundOver = true
      },
    }
  }

</script>
<style scoped>

  .bg {
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  * {
    padding: 0;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .indexBox {
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .banner {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
  }

  .myPopupBox {
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .myPopup {
    width: 31.25rem;
    height: 18.75rem;
    background: #fff;
    border-radius: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 2.0625rem;
  }

  .guanbi {
    position: absolute;
    width: 3.125rem;
    right: 1.25rem;
    top: 1.25rem;
  }







  .PPTBox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .PPTBox .pptTitle {
    text-align: center;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 2.8rem;
    color: #FFFFFF;
  }

  .PPTBox .myppt {
    width: 80%;
    height: 80%;
    margin-top: calc(10vh - 3.4375rem);
    border-radius: 0.625rem;
    border: none;
  }

  .countdown {
    position: fixed;
    right: 3.125rem;
    top: 3.125rem;
    width: 6.25rem;
    height: 6.25rem;
    background: rgba(16, 90, 137, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.75rem;
    border-radius: 3.125rem;
    color: #FE7007;
    font-weight: 600;
    border-radius: 3.125rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/index.vue